import {Component, EventEmitter, Inject, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormGroup, FormControl} from "@angular/forms";
import {debounceTime, distinctUntilChanged} from "rxjs";
import {FundService} from "../fund-service.service";

@Component({
    selector: 'add-project-credit',
    templateUrl: './add-project-credit.component.html',
    styleUrls: ['./add-project-credit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddProjectCreditComponent implements OnInit{
  public searchResult:any[] = []
  public projectStates:any[] = []
  public selectedCredits:any[] = []
  public projectLevelColumns:string[] = ['name', 'location', 'msa', 'yield']
  public creditLevelColumns:string[] = ['check', 'type', 'lt_equity', 'ownership', 'admitted_date', 'is_target']
  public creditForm: FormGroup = new FormGroup({
    project: new FormControl(null),
    fund_project_state: new FormControl(null)
  })
  public isLoading: boolean = false;
  public saveCredits: EventEmitter<any> = new EventEmitter<any>()
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data:any, private fundService: FundService) {
    this.creditForm.controls['project'].valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((value:any) => {
      this.isLoading = true;
      this.fundService.getProjectSearch(value, (response:any) => {
        this.searchResult = this._formatResult(response.data.search_projects.data)
        this.isLoading = false;
      })
    })
  }

  ngOnInit() {
    this.projectStates = this.data.fundProjectStates
    let unspecifiedState = this.projectStates.find((state:any) => state.name==='Unspecified')
    this.creditForm.controls['fund_project_state'].setValue(unspecifiedState)
  }

  private _formatResult(data:any[]){
    let results:any = []
    for(let i = 0; i < data.length; i++){
      let resultObj:any = {
        id: data[i].id,
        name: data[i].name,
        location: this.fundService.setLocationString(data[i].properties[0].entity.entityAddresses[0]?.address, 'location'),
        msa: this.fundService.setLocationString(data[i].properties[0].entity.entityAddresses[0]?.address, 'msa'),
        yieldVal: data[i].ltmodels[0]?.kpiset.kpiset_detail?.lower_tier_yield ?? null,
        creditsForms: [],
      }
      if(data[i].projectCredits.length>0){
        data[i].projectCredits.forEach((credit:any) => {
          let form:FormGroup = new FormGroup({
            id: new FormControl(credit.id),
            project_id: new FormControl(data[i].id),
            selected: new FormControl(false),
            type: new FormControl(credit.taxCreditType.level + " " + credit.taxCreditType.name + (credit.taxCreditDesignation!==null ? " " + credit.taxCreditDesignation.name : "")),
            lt_equity: new FormControl(credit.equity_amount),
            ownership: new FormControl(100),
            admitted_date: new FormControl(null),
            is_target: new FormControl(false),
          })
          resultObj.creditsForms.push(form)
        })
      }
      results.push(resultObj)
    }
    return results
  }

  public onSelected(event: any){
    if(!event.value.selected){
      this.selectedCredits = this.selectedCredits.filter((credit:any) => credit.id !== event.value.id);
    }
    if(event.value.selected){
      let project = this.searchResult.find((result:any) => result.id === event.value.project_id);
      if(project){
        let forms = project.creditsForms;
        forms.forEach((form:any) => {
          let type = event.value.type.split(" ")[0]
          if(form.value.type.split(" ")[0]===type){
            form.controls.admitted_date.setValue(event.value.admitted_date)
            form.controls.selected.setValue(true)
            form.controls.ownership.setValue(event.value.ownership)
            let values:any = {
              ...form.value,
              placement_status: this.creditForm.value.fund_project_state.id
            }
            this.selectedCredits.push(values)
          }
        })
      }
    }
  }

  public onFieldChange(event:any){
    let searchCredit = this.searchResult.filter((result:any) => result.id == event.value.project_id);
    let subCredits:any[] = []
    if(searchCredit.length>0){
      subCredits = searchCredit[0].creditsForms
    }
    if(subCredits.length > 0 && event.value.type.toLowerCase().includes('lihtc')){
      subCredits.forEach((credit:any) => {
        if(!credit.value.type.toLowerCase().includes('lihtc') && event.value.type.split(" ")[0].toLowerCase() == credit.value.type.split(" ")[0].toLowerCase()){
          // credit.controls[key].setValue()
        }
      })
    }
  }


  public save(){
    if(this.selectedCredits.length==0){
      return;
    }
    this.saveCredits.emit(this.selectedCredits)
  }

  public close(){
    this.dialogRef.close()
  }
}
